import React from "react";
import { inject, observer } from "mobx-react";
import { Steps } from "@components";
import { ProgressBusiness, } from "@business/newCreateRequest/common/progress";
import './index.less';
var StepsProgress = inject(ProgressBusiness)(observer(function (props) {
    var steps = props.steps, jump = props.jump;
    return (React.createElement("div", { className: "rsp-step-progress rsp-step-vertical my-3" },
        React.createElement("div", { className: "rsp-card pt-1" },
            React.createElement(Steps, { steps: steps, tag: "rspProgress", onChange: jump }))));
}));
export default StepsProgress;
